import {SurveysPage} from '@/pages/SurveysPage';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/AppShell';
import { MessagesRealtimeSync } from '@/components/MessagesRealtimeSync';
import { HomePage } from '@/pages/HomePage';
import { BattlepassPage } from '@/pages/BattlepassPage';
import { CalendarPage } from '@/pages/CalendarPage';
import { SpinPage } from '@/pages/SpinPage';
import { SpecialOfferPage } from '@/pages/SpecialOfferPage';
import { AuctionPage } from '@/pages/AuctionPage';
import { TitleManagerPage } from '@/pages/titlemanager/TitleManagerPage';
import { RankingPage } from '@/pages/ranking/RankingPage';
import { RankingShell } from '@/pages/ranking/RankingShell';
import { CharacterProfilePage } from '@/pages/ranking/CharacterProfilePage';
import { SchedulePage } from '@/pages/SchedulePage';
import { RegisterPage } from '@/pages/RegisterPage';
import { DropLogPage } from '@/pages/logsystem/DropLogPage';
import { ChatbotPage } from '@/pages/chatbot/ChatbotPage';
import { JobSystemPage } from '@/pages/jobsystem/JobSystemPage';
import { VipSystemPage } from '@/pages/vipsystem/VipSystemPage';
import { CuponsPage } from '@/pages/cupons/CuponsPage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { MessagesPage } from '@/pages/messages/MessagesPage';
import { NotificationsPage } from '@/pages/notifications/NotificationsPage';
import { NotificationDetailPage } from '@/pages/notifications/NotificationDetailPage';
import { UniquesHistoryPage } from '@/pages/uniques/UniquesHistoryPage';
import { DonationPage } from '@/pages/donation/DonationPage';
import { DonationSuccessPage } from '@/pages/donation/DonationSuccessPage';
import { DonationCancelPage } from '@/pages/donation/DonationCancelPage';
import { DailyTasksPage } from '@/pages/dailytasks/DailyTasksPage';
import { useLocale } from '@/context/LocaleContext';
import type { AuthUser, PlayerData } from '@/vite-env.d';

interface AppRouterProps {
  user: AuthUser;
  player: PlayerData | null;
}

function RankingGuildShell() {
  const { t } = useLocale();
  return <RankingShell title={t('ranking_guild_title')} />;
}

function RankingMasteryShell() {
  const { t } = useLocale();
  return <RankingShell title={t('ranking_mastery_title')} />;
}

function RankingArenaShell() {
  const { t } = useLocale();
  return <RankingShell title={t('ranking_arena_title')} />;
}

export function AppRouter({ user, player }: AppRouterProps) {
  return (
    <BrowserRouter>
      <MessagesRealtimeSync />
      <Routes>
        <Route element={<AppShell user={user} initialPlayer={player} />}>
          <Route index element={<HomePage />} />
          <Route path="battlepass" element={<BattlepassPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="spin" element={<SpinPage />} />
          <Route path="specialoffert" element={<SpecialOfferPage />} />
          <Route path="auctionsystem" element={<AuctionPage />} />
          <Route path="titlemanager" element={<TitleManagerPage />} />
          <Route path="ranking" element={<RankingPage />} />
                    <Route path="ranking/player" element={<RankingPage key="player" category="player" />} />
          <Route path="ranking/gold" element={<RankingPage key="gold" category="gold" />} />
          <Route path="ranking/uniques" element={<RankingPage key="uniques" category="uniques" />} />
          <Route path="ranking/battle" element={<RankingPage key="battle" category="battle" />} />
          <Route path="ranking/job" element={<RankingPage key="job" category="job" />} />
          <Route path="ranking/season" element={<RankingPage key="season" category="season" />} />
          <Route path="ranking/guild" element={<RankingGuildShell />} />
          <Route path="ranking/mastery/:type" element={<RankingMasteryShell />} />
          <Route path="ranking/arena/:type" element={<RankingArenaShell />} />
          <Route path="ranking/character-profile/:charId" element={<CharacterProfilePage />} />
          <Route path="uniqueshistory" element={<UniquesHistoryPage />} />
          <Route path="schedule" element={<SchedulePage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="chatbot" element={<ChatbotPage />} />
          <Route path="logsystem" element={<DropLogPage />} />
          <Route path="jobsystem" element={<JobSystemPage />} />
          <Route path="vipsystem" element={<VipSystemPage />} />
          <Route path="cupons" element={<CuponsPage />} />
          <Route path="surveys" element={<SurveysPage />} /><Route path="dailytasks" element={<DailyTasksPage />} />
          <Route path="donation" element={<DonationPage />} />
          <Route path="donation/success" element={<DonationSuccessPage />} />
          <Route path="donation/cancel" element={<DonationCancelPage />} />
          <Route path="setting" element={<SettingsPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="notifications/:id" element={<NotificationDetailPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

